export default __webpack_public_path__ + "static/media/scallops.6ce6d41b.jpg";